<template>
    <div style="display: flex;padding-block: 4px;">
        <div style="display: flex;align-items: center;flex-grow: 1;" v-for="label in labels">
            <div style="display: flex;align-items: center;flex-grow: 1;">
                <div style="position: relative;" :style="{ 'padding-inline': padding + 'px' }" >
                    <label style="position: absolute;top: 50%; left: 50%;transform: translate(-50%, -50%);">{{label.name}}</label>
                </div>

                <input type="number" v-model.number="label.value" style="margin-left: 10px;" />
            </div>
            <div style="margin-left: 10px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputRowComp",
    props: {
        labels: {
            type: Array,
            required: true
        },
        padding: {
            type: Number,
            required: false,
            default: 16
        }
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
.insp-section label { color: var(--muted); font-size: 12px; }
.insp-section input[type="number"], .insp-section input[type="text"], .insp-section select { width: 100%; height: 28px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); color: var(--text); padding: 0 8px; }
.insp-section input[type="color"] { width: 36px; height: 28px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel); padding: 0; }
</style>